import React from 'react';

export default function CheckIcon({className}) {
	return (
		<svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.7 8.5"><path d="M3.7 8.5c-.2 0-.4-.1-.5-.2l-3-2.9c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l2.3 2.3L8.3.3c.2-.3.7-.4 1-.2.3.2.4.7.2 1l-5.2 7c-.1.3-.3.4-.6.4z"/></svg>
	);
}
